import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

const cardSortingTooltipContent = (
  <Stack spacing={1} sx={{ maxWidth: 280, py: 0.5 }}>
    <Typography variant="subtitle2" sx={{ color: 'common.white', fontWeight: 700 }}>
      Card Sorting
    </Typography>
    <Typography variant="caption" sx={{ color: 'grey.200' }}>
      Custom: Ideas stay in the manual order you set by dragging cards.
    </Typography>
    <Typography variant="caption" sx={{ color: 'grey.200' }}>
      Automatic: Ideas are ordered automatically by the selected ranking mode.
    </Typography>
  </Stack>
);

const CardSortingTooltip = () => (
  <Tooltip title={cardSortingTooltipContent} arrow placement="right">
    <IconButton size="small" aria-label="Show card sorting help">
      <InfoOutlinedIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Tooltip>
);

export default CardSortingTooltip;
